import * as services from '@api';
import { getType, isType } from '@utils';
import { getMscByDomainKey } from 'ynf-core-engine/request';
import reactRender from '@utils/reactRender';
import { bNeedRefresh } from './navigate';
import BatchNotice from '@src/components/batchNotice';
import { utils } from 'ynf-core-middleware';
const { uuid } = utils;
const { Button, Progress } = window.TinperNext || {};

/**
 * getDataSourceByAlias
 * @param alias 
 * @param dataSource 
 * @param level 
 * @returns 
 */
export function getDataSourceByAlias(alias = '', dataSource = {}, level = 0) {
  let ds: any;
  (function recur (alias: string, dataSource: any, level = 0) {
    if (ds || !alias || !dataSource) return;
    for (const x in dataSource) {
      const item = dataSource[x];
      if (item.alias === alias) {
        ds = [item, level];
      } else {
        if (item.children && 
          item.children.length) {
          recur(alias, item.children, level + 1);
        }
      }
    }    
  })(alias, dataSource, level);
  console.log('------- getDataSourceByAlias ---------', dataSource, alias, ds?.[0], ds?.[1]);
  return ds || [];
}

/**
 * getRecurTable
 * @param rootStore 
 * @param dataSource 
 * @param callback 
 */
export function getRecurTable(rootStore: any, dataSource: any, callback: any) {
  (function recur(rootStore = {}, ds = {}, parent: any, callback) {
    if (!rootStore || !ds) return;
    const { alias = '', children = [] } = ds;
    const store = rootStore.getStoreByAlias(alias);
    if (store?.storeType === 'TableStore') {
      if (isType(callback, 'Function')) {
        callback(
          { alias, ds, store }, 
          { alias: parent?.alias, ds: parent, store: rootStore.getStoreByAlias(parent?.alias) }
        );
      }
    }
    if (children && 
      children.length) {
      children.forEach((child: any) => {
        recur(rootStore, child, ds, callback);
      });
    }
  })(rootStore, dataSource, null, callback);
}

/**
 * getRecurDsParams
 * @param dataSource 
 * @returns 
 */
export function getRecurDsParams(dataSource: any) {
  return (function recur(ds = {}, node = {}) {
    const { alias = '', children } = ds;
    if (!alias) return null;
    node.alias = alias;
    if (children && 
      children.length) {
      node.children = [];
      children.forEach((child: any) => {
        const childNode = recur(child);
        if (childNode) {
          node.children.push(childNode);
        }
      });
    }
    return node;
  })(dataSource);
}

/**
 * mergeDetailCopyData
 * @param rootStore 
 * @param dataSource 
 * @param callback 
 */
export function mergeDetailCopyData(dataSource: any, detailData: any = {}, copyData: any = {}, rootStore: any, fileList: any = []) {
  (function recur(ds = {}, detailData = {}, copyData = {}, isTable = false) {
    const { alias = '', children = [], fieldsArr = {} } = ds;
    // 找到是附件的字段
    const fileMap: any = {};
    fieldsArr.forEach((item: any) => {
      const fileType = ['image', 'attachment'];
      const { bizType, alias } = item;
      if (fileType.includes(bizType)) {
        fileMap[alias] = true;
      }
    })
    // --end---
    Object.assign(detailData, { _status: 'Insert' });
    /**
     * copyData 里有时候有附件、有时候没有
     * 有：detailData.fujian = copyData.fujian
     * 没有：detailData.fujian = '新生成uuid'
    */
    Object.entries(copyData).forEach(([key, value]) => {
      if (!children.find((v: any) => v.alias === key)) {
        // 非子表字段
        // null 或者 有值 表示给原本字段赋值
        if (copyData[key] !== undefined) {
          detailData[key] = copyData[key];
          if (fileMap[key]) {
            delete fileMap[key];
          }
        }
      }
    });
    // 如果copyData里没有附件字段就要重新遍历fileMap
    const tableStoreObj: any = {}
    const tableStores = rootStore.cardStore.tableStores;
    tableStores?.forEach((item: any) => {
      tableStoreObj[item.dataSource] = rootStore?.[item.alias];
      if (item?.children?.length) {
        item.children.forEach((subItem: any) => {
          tableStoreObj[subItem.dataSource] = rootStore?.[subItem.alias];
        })
      }
    })
    let store: any;
    const CardStore = rootStore.cardStore;
    if (!isTable) {
      store = rootStore?.[CardStore.formStore]
    } else {
      store = tableStoreObj[alias]?.columns
    }
    Object.entries(fileMap).forEach(([key]) => {
      if (detailData[key]) {
        // 说明这个值要被复制
        const randomId = uuid();
        // 取objectName 这里有可能读不到。需要ynf支持
        // const objectName = pageStore?.query?.domainKey || 'iuap-yonbuilder-runtime';
        const pageStore = rootStore.pageStore;
        const simpleStore = store?.get?.(key);
        const businessType = simpleStore?.objectName || simpleStore?.defaultObjectName || simpleStore?.domainKey
        let objectName = businessType || getMscByDomainKey?.(pageStore?.query?.domainKey) || pageStore?.query?.domainKey || 'developplatform';
        if (!businessType && objectName === 'developplatform' && pageStore?.query?.domainKey === 'developplatform') {
          objectName = 'iuap-yonbuilder-runtime'
        }
        fileList.push({
          sourceObjectId: detailData[key],
          sourceObjectName: objectName,
          targetObjectId: randomId,
          targetObjectName: objectName,
          isTable
        });
        detailData[key] = randomId;
      }
    })
    if (detailData.id) detailData.id = null// 复制时多选参照要把id去掉，不然保存不了
    if (children && 
      children.length) {
        children.forEach((childDs: any = {}) => {
          const childAlias = childDs.alias;
          if (copyData?.[childAlias]?.length) {
            detailData[childAlias] = detailData[childAlias] || [];
            const childCopyData = copyData[childAlias][0];
            if (detailData[childAlias].length !== 0) {
              detailData[childAlias].forEach((childDetailData: any) => {
                recur(childDs, childDetailData, childCopyData, true);
              })
            }
          }
        });
      }
    })(dataSource, detailData, copyData);
    console.log('-----  after mergeDetailCopyData ------', detailData, copyData);
    return detailData;
}

/**
 * mergeDetailAddData
 * @param rootStore 
 * @param dataSource 
 * @param callback 
 */
export function mergeDetailAddData(dataSource: any, detailData: any = {}, addData: any = {}) {
  console.log('-----  before mergeDetailAddData ------', ...(JSON.parse(JSON.stringify([...arguments]))));
  (function recur(ds = {}, detailData = {}, addData = {}) {
    const { alias = '', children = [] } = ds;
    if (detailData._status !== 'Delete') {
      detailData._status = 'Insert';
    }
    Object.entries(addData).forEach(([key, value]) => {
      if (!children.find((v: any) => v.alias === key)) {
        if (addData[key] !== undefined) {
          detailData[key] = addData[key];
        }
      }
    })
    if (children && 
      children.length) {
        children.forEach((childDs: any = {}) => {
          const childAlias = childDs.alias;
          const childAddData = addData?.[childAlias]?.[0];
          if (detailData[childAlias]) {
            detailData[childAlias].forEach((childDetailData: any) => {
              recur(childDs, childDetailData, childAddData);
            })
          }
        });
      }
    })(dataSource, detailData, addData);
    console.log('-----  after mergeDetailAddData ------', detailData, addData);
    return detailData;
}

/**
 * requiredValidate
 * @param params 
 * @param requireds 
 */
export const requiredValidate = function(params = {}, requireds: any = []) {
  const inValidates = requireds.filter(v => !params.hasOwnProperty(v));
  if (inValidates.length) {
    throw new Error(`${this.name}，Params缺少必须字段:[${inValidates}]，请补充参数并重试`)//@notranslate
  }
}

/**
 * getHoverRow
 * @param rootStore 
 * @param options {
 *   tableStoreKey: string
 * }
 * @param event 
 * @param eventOptions 
 * @returns 
 */
export const getHoverRow = function(rootStore: any, options: any = {}, event: any, eventOptions: any) {
  const { tableStoreKey = 'tableStore' } = options;
  const tableStore = rootStore.get(tableStoreKey);
  if (options.tableStoreKey) {
    if (!tableStore) throw (new Error(`The tableStore[${tableStoreKey}] not found`));
  }
  const hoverRow = event?.rowData ?? event?.rowStore ?? eventOptions?.rowStore;
  return [hoverRow, tableStore];
}

/**
 * batchByAsyncKey
 * @param url 
 * @param asyncKey 
 * @returns 
 */
async function batchByAsyncKey(rootStore: any, options: any = {}) {
  const { pageStore = {}, utils = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const { asyncKey = '', url = '' } = options;
  let res = await services.batchByAsyncKey({ url: `/mdf-node/qtmProxy${url}`, params: { ...query, asyncKey } })
  res = JSON.parse(res?.['data'] || '{}');
  const { totalCount = 0, successCount = 0, failCount = 0 } = res || {};
  if ((successCount + failCount) >= totalCount) {
    return res;
  }
  return Promise.reject(res);
}

/**
 * batchByAsyncKeyTask
 * @param rootStore 
 * @param options 
 */
export async function batchByAsyncKeyTask(rootStore: any, options: any = {}) {
  const { pageStore = {}, utils = {} } = rootStore;
  const { title = '' } = options;
  const key = uuid(), progressKey = `progress_${key}`;
  const taskTitle = lang.localeUuid('UID:P_CORE-YNF-FE_1895277C05B80007', { title }, '批量<%=title%>任务已转入后台执行');
  rootStore.utils.notice.warning({ 
    key, 
    duration: Progress? 15: 5, 
    title: taskTitle,// 批量<%=title%>任务已转入后台执行
    content: Progress ? <div id={ progressKey }></div> : taskTitle
  });
  const processRender = reactRender(Progress, { percent: 0, status: 'active' }, () => document.querySelector(`#${progressKey}`))
  const rollPolling = (prevRes: any = {}) => {
    setTimeout(async () => {
      try {
        processRender.update({ percent: prevRes.percentage ?? 0 });
        const res = await batchByAsyncKey(rootStore, options);
        const resKey = uuid(); 
        const message = { 
          key: resKey,
          title: lang.localeUuid('UID:P_CORE-YNF-FE_189529FC05B80009', { title }, '批量<%=title%>任务执行完毕'),// 批量<%=title%>任务执行完毕
          content: <BatchNotice title = { title } content={ res }/>, 
          duration: Button? 10: 5, 
          btn: Button && <Button size="sm" colors="primary">{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002D', '知道了')}</Button>,
          onClose() {
            rootStore.utils.notice.close(key);
            rootStore.utils.notice.close(resKey);
          }
        };
        processRender.update({ percent: 100 });
        if (res.failCount) {
          if (res.failCount >= res.totalCount) {
            rootStore.utils.notice.danger(message);
          } else {
            rootStore.utils.notice.warning(message);
            bNeedRefresh.call(this, rootStore);
          }
        } else {
          rootStore.utils.notice.success(message);
          bNeedRefresh.call(this, rootStore);
        }
      } catch (res: any) {
        if (res.code && res.code != 200) {
          utils.message.danger(res.message);
        } else {
          rollPolling(res);
        }
      }
    }, 2000)
  }
  rollPolling();
}

/**
 * 页面状态类型
 */
export enum BillStatusType {
  OPEN = '0',
  AUDIT = '1',
  AUDITED = '2',
  STOP = '3',
  DisapproveDraft = '4'
}



export function filterAndModifyData(obj:any) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const { children, id, verifyState, ...rest } = obj; // 解构对象，排除指定属性

  for (let key in rest) {
    if (Array.isArray(rest[key])) {
      rest[key] = rest[key].map((item:any) => {
        if (item && typeof item === 'object') {
          const { id, ...newItem } = item;
          return Object.assign(newItem, { _status: 'Insert' });
        }
        return item;
      });
    }
  }

  return rest;
}

// 前一个对象相对于第二个对象的差集
export function getObjectDifference(obj1: any, obj2: any) {
  const diff : any= {};
  
  // 遍历第一个对象的所有键值对
  for (const key in obj1) {
    // 如果第二个对象没有这个键，或者键对应的值不相等
    if (obj1[key] !== obj2[key]) {
      // 将这个键值对添加到差异对象中
      diff[key] = obj1[key];
    }
  }
  
  // 返回有差异的键值对
  return diff;
}